import React from "react";

import Image from "next/image";
import { useWindowSize } from "@/shared/hooks/useWindowSize";
import Screen from "@/constants/screens";

import Link from "next/link";
import routes from "@/constants/routes";

const GeneralPropertyCard = () => {
  const { width } = useWindowSize();

  return (
    <div
      className="flex flex-col h-full group bg-landing-blue shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 rounded-tl-[15px] rounded-tr-[15px] rounded-bl-[15px] rounded-br-[15px] pl-8 pr-8 pt-4 py-4 "
      role="tab"
    >
      <div className="flex w-full  relative  ">
        <Image
          src="/landlords/hero-landlords-about-us.svg"
          alt="General Property"
          className="rounded-tl-[15px] rounded-tr-[15px]"
          priority
          objectFit="fill"
          style={{ width: "100%", height: "auto" }}
          width={width < Screen.Tablet_768 ? 520 : 350}
          height={270}
        />
      </div>
      <div className="flex flex-col mt-2 xs:mt-4  w-full h-full justify-between">
        <p className="text-center md:text-left xl:text-[32px] lg:text-[30px] md:text-[28px] sm:text-[26px] text-[24px] leading-8 font-semibold w-full text-landing-white">
          Looking for somewhere else
          <span className="text-landing-orange"> to call home?</span>
        </p>
        <div
          style={{
            letterSpacing: "-0.01em",
            lineHeight: "30px",
          }}
          className="hidden md:flex font-serif text-white font-100 mt-4 xl:text-[26px] lg:text-[24px] md:text-[22px] sm:text-[20px] text-[18px] "
        >
          Let us know where you’re looking and we’ll let you know when we’re available in your town.
        </div>
        <div className="flex  justify-center mt-2 xs:mt-4 mb-2 sm:mb-0   items-end ">
          <Link href={routes.registerInterest}>
            <a className="min-w-[9rem] flex items-center justify-center md:max-w-fit  ml:0  px-4 py-3 text-base font-bold transition duration-300 ease-in-out transform rounded shadow bg-landing-orange text-landing-blue hover:scale-105">
              Tell us where
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GeneralPropertyCard;
